/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';
import { Form, Select } from 'antd';
import DokanCard from '../card/DokanCard';
import DokanInputLabel from '../form/DokanInputLabel';
import DokanSelectField from '../form/DokanSelectField';
import { handleProductInput } from '../../redux/products/productsActions';

function Status() {
    const dispatch = useDispatch();
    const handleChangeInput = (name, value = '', e = null) => {
        dispatch(handleProductInput(name, value, e));
    };

    const status = [
        { value: 'draft', name: 'Draft' },
        { value: 'pending', name: 'Pending' },
        { value: 'publish', name: 'Publish' },
    ];
    const visibility = [{ value: 'public', name: 'Public' }];

    const options = status.map((d) => <Select.Option key={d.value}>{d.name}</Select.Option>);
    const visibilityOptions = visibility.map((d) => (
        <Select.Option key={d.value}>{d.name}</Select.Option>
    ));
    const getInputData = useSelector((state) => state.products.productInputData);
    const setInputData = getInputData.status;
    return (
        <>
            <DokanCard hasTitle cardTitle="Product Status">
                <Form.Item name="status">
                    <Select
                        className="mt-20px dokan-select"
                        showArrow
                        style={{ width: '100%' }}
                        onChange={(value) => handleChangeInput('status', value)}
                        placeholder="Allow Backorders"
                        value={setInputData}
                        defaultValue={setInputData}
                    >
                        {options}
                    </Select>
                </Form.Item>
                <DokanInputLabel>Visibility</DokanInputLabel>
                <Form.Item name="visibility">
                    <Select
                        className="mt-20px dokan-select"
                        showArrow
                        style={{ width: '100%' }}
                        onChange={(value) => handleChangeInput('visibility', value)}
                        placeholder="Select Visibility"
                    >
                        {visibilityOptions}
                    </Select>
                </Form.Item>
            </DokanCard>
        </>
    );
}

export default Status;
